import { useLazyGetSensitiveDataFieldValueQuery } from "apis/sensitiveData";
import { Button } from "components/DesignSystem/Button/Button";
import { CopyIcon } from "components/icons/CopyIcon";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";
import { useToast } from "hooks/useToast";
import { useParams } from "react-router-dom";
import { BackendError } from "types/utils/error";

export const SensitiveDataCopyButton = ({
  formId,
  attributeId,
  value,
  entityId: entityIdFromProps,
}: {
  formId: string;
  attributeId: string;
  value?: string;
  entityId?: string;
}) => {
  const { entityId: entityIdFromRoute } = useParams<{ entityId: string }>();
  const entityId = entityIdFromProps ?? entityIdFromRoute;

  const [getFieldValue, { isFetching }] =
    useLazyGetSensitiveDataFieldValueQuery();
  const { copyToClipboard } = useCopyToClipboard();
  const { alertToast } = useToast();

  const handleCopy = async () => {
    if (value) {
      await copyToClipboard(value);
      return;
    }

    try {
      const { encoded_value } = await getFieldValue({
        entityId,
        formId,
        attributeId,
      }).unwrap();

      await copyToClipboard(encoded_value);
    } catch (error) {
      alertToast({
        message:
          (error as BackendError)?.data?.error?.message ??
          "Could not copy the value",
      });
    }
  };

  return (
    <Button
      type="button"
      size="xxsmall"
      customType="ghost_icon"
      onClick={handleCopy}
      isLoading={isFetching}
      disabled={isFetching}
      title="Copy"
    >
      <CopyIcon className="t-text-text-30" />
    </Button>
  );
};
